import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LogoutButton.css';
import { LogOut } from 'lucide-react';
import apiConfig from '../config/apiConfig';

interface LogoutButtonProps {
  className?: string;
  style?: React.CSSProperties;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className = "logout-btn-dropdown", style }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(
        `${apiConfig.API_BASE_URL}/auth/logout`,
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.error('Logout failed:', error);
    }

    // Clear localstorage and navigate to home page
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');

    navigate('/');
  };

  return (
    <button className={className} style={style} onClick={handleLogout}>
      <LogOut size={16} />
      <span>Logout</span>
    </button>
  );
};

export default LogoutButton;